import React from "react";
import { Breakdown } from "./Breakdown";
import { Stack } from "@bookingcom/bui-react";
import { Atol, SIRF, Disclaimers } from "./banners";
import {
  useUnifiedPriceBreakdownPostBookingController,
  type UnifiedPriceBreakdownPostBookingControllerProps
} from "./useUnifiedPriceBreakdown.PostBooking.controller";
import useEvents from "hooks/useEvents";

export type UnifiedPriceBreakdownPostBookingProps = UnifiedPriceBreakdownPostBookingControllerProps;

export function UnifiedPriceBreakdownPostBooking(props: UnifiedPriceBreakdownPostBookingProps) {
  const {
    unifiedPriceBreakdown,
    isHungaryDepartingRyanAir,
    disclaimers,
    isWithDiscount,
    addedItems,
    routeName,
    expandedByDefault
  } = useUnifiedPriceBreakdownPostBookingController(props);

  const { grumble } = useEvents();

  if (!unifiedPriceBreakdown) {
    grumble("unifiedPriceBreakdown object unavailable", { controller: "PostBooking", routeName });
    return null;
  }

  return (
    <Stack>
      <Breakdown
        {...unifiedPriceBreakdown}
        isHungaryDepartingRyanAir={isHungaryDepartingRyanAir}
        expandedByDefault={expandedByDefault}
        addedItems={addedItems}
        isWithDiscount={isWithDiscount} // flights_unified_price_breakdown_pb
      />
      <Disclaimers disclaimers={disclaimers} />
      <Atol />
      <SIRF />
    </Stack>
  );
}
